<section class="dz-card" [class.dz-card--recolhido]="!aberto()">
  <div class="dz-card__head">
    <h2 class="dz-card__title">
      <button
        type="button"
        class="dz-card__toggle"
        [attr.aria-expanded]="aberto()"
        aria-controls="registro-mapa-corpo"
        [title]="aberto() ? 'Recolher' : 'Expandir'"
        (click)="aberto.set(!aberto())">
        <span class="dz-card__icon" aria-hidden="true">🕸️</span>
        {{ title() }}
        <i class="pi pi-chevron-down dz-card__chevron" aria-hidden="true"></i>
      </button>
    </h2>

    @if (aberto()) {
      <div class="dz-card__actions">
        <div class="prof">
          <span class="dz-label">Profundidade</span>
          <div class="dz-seg" role="group" aria-label="Profundidade">
            @for (p of profundidades; track p) {
              <button
                type="button"
                class="dz-seg__btn"
                [class.dz-seg__btn--on]="prof() === p"
                [attr.aria-pressed]="prof() === p"
                (click)="prof.set(p)">
                {{ p === 'auto' ? 'Auto' : p }}
              </button>
            }
          </div>
          @if (prof() === 'auto' && profundidadeUsada() !== null) {
            <span class="prof__hint">→ {{ profundidadeUsada() }}</span>
          }
        </div>

        @if (pronto()) {
          <div class="dz-seg" role="group" aria-label="Visão">
            @for (v of visoes(); track v.valor) {
              <button
                type="button"
                class="dz-seg__btn"
                [class.dz-seg__btn--on]="visao() === v.valor"
                [attr.aria-pressed]="visao() === v.valor"
                (click)="visao.set(v.valor)">
                {{ v.rotulo }}
              </button>
            }
          </div>
          <button
            #expandir
            type="button"
            class="dz-btn-outline"
            title="Expandir para tela cheia"
            (click)="telaCheia.set(true)">
            ⤢ Expandir
          </button>
        }
      </div>
    }
  </div>

  @if (aberto()) {
    <div class="dz-card__body" id="registro-mapa-corpo">
      @if (base().carregando) {
        <div class="caixa">
          <app-cog-loading-spinner [size]="72" />
          <span>Carregando o mapa societário…</span>
        </div>
      } @else if (base().erro) {
        <p class="dz-muted">
          Não foi possível carregar o mapa societário.
          <button type="button" class="link" (click)="tentarDeNovo()">Tentar de novo</button>
        </p>
      } @else if (semDados()) {
        <p class="dz-muted">Sem vínculos societários para plotar.</p>
      } @else if (telaCheia()) {
        <!-- A visão vive UMA vez: enquanto a tela cheia está aberta, ela é renderizada só lá (sem
           dois mapas Leaflet, dois ResizeObservers, e sem perder o estado ao fechar). -->
        <p class="dz-muted">Aberto em tela cheia.</p>
      } @else {
        <ng-container *ngTemplateOutlet="conteudo; context: { $implicit: false }" />
      }

      @if (mostraLegenda()) {
        <ul class="dz-legend">
          <li>
            <span
              class="dz-dot"
              [style.background]="highlightRoot() ? cores.raiz : cores.empresa"></span>
            empresa consultada
          </li>
          <li><span class="dz-dot" [style.background]="cores.empresa"></span> empresa ligada</li>
          <li><span class="dz-dot" [style.background]="cores.pessoa"></span> pessoa</li>
          <li><span class="dz-dot dz-dot--ring"></span> situação ≠ ativa</li>
        </ul>
      }
    </div>
  }
</section>

<!-- Tela cheia: a mesma visão, sobre a página inteira, como o "⤢ Expandir" do Dossiê. -->
@if (telaCheia() && pronto()) {
  <div
    class="cheia"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="title() + ' · ' + rotuloVisao()">
    <div class="cheia__head">
      <h2 class="cheia__title">{{ title() }} · {{ rotuloVisao() }}</h2>
      <button
        #fecharCheia
        type="button"
        class="cheia__close"
        aria-label="Fechar visualização expandida"
        (click)="telaCheia.set(false)">
        ✕
      </button>
    </div>
    <div class="cheia__body">
      <ng-container *ngTemplateOutlet="conteudo; context: { $implicit: true }" />
    </div>
  </div>
}

<ng-template #conteudo let-cheia>
  @if (truncado(); as n) {
    <p class="dz-note dz-note--warn aviso">
      O mapa foi recortado em {{ n }} nós. Reduza a profundidade para ver o todo.
    </p>
  }
  @for (aviso of avisos(); track aviso) {
    <p class="dz-note aviso">{{ aviso }}</p>
  }

  @switch (estado().tipo) {
    @case ('carregando') {
      <div class="caixa" [class.caixa--cheia]="cheia">
        <app-cog-loading-spinner [size]="72" />
        <span>{{ mensagemCarregando[visao()] }}</span>
        @if (visao() === 'geo') {
          <span class="caixa__detalhe">Pode levar alguns segundos na primeira vez.</span>
        }
      </div>
    }
    @case ('erro') {
      @if (visao() === 'geo') {
        <!-- A Geo falha de verdade só depois de UMA nova tentativa automática; aí vale dizer por
             quê, porque o normal é funcionar na segunda chamada (as coordenadas já resolvidas
             ficam no cache do Dossiê). -->
        <div class="caixa caixa--erro" [class.caixa--cheia]="cheia">
          <span>Não foi possível localizar as empresas no mapa agora.</span>
          <span class="caixa__detalhe">
            A primeira consulta geocodifica os endereços e às vezes não completa. As coordenadas já
            resolvidas ficam guardadas, então tentar de novo costuma funcionar.
          </span>
          <button type="button" class="link" (click)="tentarDeNovo()">Tentar de novo</button>
        </div>
      } @else {
        <p class="dz-muted">
          Não foi possível montar esta visualização.
          <button type="button" class="link" (click)="tentarDeNovo()">Tentar de novo</button>
        </p>
      }
    }
    @case ('mapa') {
      <div class="mapa" [class.mapa--cheia]="cheia">
        <div class="mapa__layouts">
          <div class="dz-seg" role="group" aria-label="Layout">
            @for (l of layouts; track l.valor) {
              <button
                type="button"
                class="dz-seg__btn"
                [class.dz-seg__btn--on]="layout() === l.valor"
                [attr.aria-pressed]="layout() === l.valor"
                (click)="layout.set(l.valor)">
                {{ l.rotulo }}
              </button>
            }
          </div>
        </div>
        <div class="mapa__grafo">
          <app-registry-graph [grafo]="$any(estado()).dado" [altura]="cheia ? '100%' : '558px'" />
        </div>
      </div>
    }
    @case ('geo') {
      <app-registry-geo-map
        [geo]="$any(estado()).dado"
        [altura]="cheia ? '100%' : '558px'"
        [class.cheio]="cheia" />
    }
    @case ('arvore') {
      <app-registry-tree-node [no]="$any(estado()).dado.arvore" [aberto]="true" />
    }
    @case ('matriz') {
      <app-registry-matrix [visao]="$any(estado()).dado" />
    }
    @case ('relacoes') {
      <app-registry-relations [visao]="$any(estado()).dado" />
    }
    @case ('estrutura') {
      <app-registry-structures [visao]="$any(estado()).dado" />
    }
    @case ('controle') {
      <app-registry-control [visao]="$any(estado()).dado" />
    }
  }
</ng-template>
